module.exports = __webpack_public_path__ + "assets/8269d9849597567d5e4a3a038980baf4.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/mystery/PostBigAdd2.mp3
 ** module id = 351
 ** module chunks = 0
 **/